/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./healthStatusColumn.vue?vue&type=template&id=812a1ebc&scoped=true"
import script from "./healthStatusColumn.vue?vue&type=script&lang=js"
export * from "./healthStatusColumn.vue?vue&type=script&lang=js"
import style0 from "./healthStatusColumn.vue?vue&type=style&index=0&id=812a1ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812a1ebc",
  null
  
)

export default component.exports